const { htmlToText } = require('html-to-text');

exports.stripHTML = input => {
  return htmlToText(input, {
    wordwrap: false,
    selectors: [{ selector: 'a', options: { ignoreHref: true } }],
  });
};
